var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.543 15.2031C11.1562 15.5898 10.5586 15.5898 10.1719 15.2031L7.92188 12.9531C7.53516 12.5664 7.53516 11.9688 7.92188 11.582C8.30859 11.1953 8.90625 11.1953 9.29297 11.582L10.875 13.1289L14.6719 9.33203C15.0586 8.94531 15.6562 8.94531 16.043 9.33203C16.4297 9.71875 16.4297 10.3164 16.043 10.7031L11.543 15.2031ZM21 12.25C21 17.2422 16.957 21.25 12 21.25C7.00781 21.25 3 17.2422 3 12.25C3 7.29297 7.00781 3.25 12 3.25C16.957 3.25 21 7.29297 21 12.25ZM12 4.9375C7.95703 4.9375 4.6875 8.24219 4.6875 12.25C4.6875 16.293 7.95703 19.5625 12 19.5625C16.0078 19.5625 19.3125 16.293 19.3125 12.25C19.3125 8.24219 16.0078 4.9375 12 4.9375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCircle);
export default __webpack_public_path__ + "static/media/VCircle.5885106e6d27b351b82e6ae91789c802.svg";
export { ForwardRef as ReactComponent };